import { getQuartzConfig } from 'quartz-config/evaluable';
import { invariant } from 'quartz/invariant';
const quartzConfig = getQuartzConfig();
/* invariant(quartzConfig.type === 'application') */
;
if ( /* quartzConfig.logFetchErrors !== false */true) {
  const {
    configureLogfetchErrors
  } =
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  require('../internal/logfetch-error-monitoring');
  configureLogfetchErrors(quartzConfig.logFetchErrors || {});
}